import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "31",
  viewBox: "0 0 30 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.83302 0.0546875L14.695 4.01643L7.88917 7.94576L1.02722 3.98402L7.83302 0.0546875ZM8.97036 9.63094L15.666 5.76518V13.6219L8.97036 17.4876V9.63094ZM6.97036 9.72469V17.6462L0 13.6219V5.70035L6.97036 9.72469ZM0.0850643 4.52797L0 4.67531V4.57709L0.0850643 4.52797ZM21.969 12.3139L28.8296 16.2749L22.0251 20.2035L15.1645 16.2425L21.969 12.3139ZM23.1064 21.8886L29.8015 18.0232V25.8801L23.1064 29.7455V21.8886ZM21.969 30.4022L21.9688 30.402H21.9692L21.969 30.4022ZM21.1064 21.9824V29.9041L14.1365 25.8801V17.9584L21.1064 21.9824ZM14.2208 16.7873L14.1365 16.9333V16.8359L14.2208 16.7873Z",
      fill: "#F7F7F7"
    }, null, -1)
  ])))
}
export default { render: render }